<template>
    <div class="main" style="margin-top:70px;width: 64%;padding: 30px 18%;">
				<div style="float:left;width:20%;height:200px;background-color: #98273A">
					<div style="font-size: 26px;font-weight: 900;color: white;margin-top: 70px;padding-left: 10%;">合作伙伴</div>
					<div style="color: white;margin-top: 5px;padding-left: 10%;">Partners</div>
					<div style="margin-top: 5px;margin-left: 10%;width: 20px;height: 4px;background-color: white;"></div>
				</div>
        <div class="scroll-container" style="height:200px;width:calc(80% - 4px);border: 1px solid #EAEAEA;" @mouseenter="toggleClick()" @mouseleave="toggleClick()">
            <div v-for="(item,index) in 36" :key="index" class="scroll-item" style="left: 0px;line-height: 200px;width: 16%;height: 120px;text-align: center;margin-right: 2%;margin-left: 2%;margin-top: 40px;margin-bottom: 40px;border: 1px solid #EAEAEA;" :style="styleFormatter(index - 1)" ref="scrollItem">
                <img style="width: 100%;" :src="'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/'+(index+1)+'.png'">
								<!-- <img src="../../assets/partners/1.png"> -->
            </div>
        </div>

        <!-- <div class="controller">
            <button class="btn" @click="toggleClick">{{ isScrolling ? '暂停滚动' : '开始滚动' }}</button>
        </div> -->

    </div>
</template>

<script>
    export default {
        data () {
            return {

                imgList: [
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                    // 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/partners/1.png',
                ],
								imgsrc:'',
                // 每个元素的宽度
                width: 200,
                // 滚动速度
                speed: 30,
                isScrolling: false
            }
        },
        mounted () {
            this.initListener()
						this.toggleClick()
        },
        methods: {
            toggleClick () {
                if (this.isScrolling) {
                    this.isScrolling = false
                    this.pause()
                } else {
                    this.isScrolling = true
                    this.scroll()
                }
            },

            // 根据索引计算当前元素所在位置
            styleFormatter (index) {
                return {
                    left: `${index * this.width}px`
                }
            },

            // 控制滚动开始
            scroll () {
                const elementList = this.$refs.scrollItem
                elementList.forEach(ele => {
                    ele.style.transitionDuration = `${(ele.offsetLeft + this.width) / this.speed}s`
                    ele.style.left = `-${this.width}px`
                })
            },

            // 暂停滚动
            pause () {
                const elementList = this.$refs.scrollItem
                elementList.forEach(ele => {
                    const styles = getComputedStyle(ele, null)
                    console.log(styles.left)
                    ele.style.transitionDuration = '0s'
                    ele.style.left = `${styles.left}`
                })
            },

            // 初始化listener，监听滚动动画
            // 当元素完全滚动至显示范围外时，则将该元素插入队尾
            initListener () {
                const elementList = this.$refs.scrollItem

                elementList.forEach(ele => {
                    // 当动画结束后会触发transitionend事件
                    ele.addEventListener('transitionend', () => {
                        // 计算队尾位置
                        const lastestElementPosition = this.lastestElementPosition()
                        ele.style.transitionDuration = `0s`
                        ele.style.left = `${lastestElementPosition + this.width}px`

                        // 渲染完毕之后开始滚动
                        this.$nextTick(() => {
                            ele.style.transitionDuration = `${(ele.offsetLeft + 200) / this.speed}s`
                            ele.style.left = `-${this.width}px`
                        })
                    })
                })
            },

            // 计算最后一个元素的位置
            lastestElementPosition () {
                const elementList = this.$refs.scrollItem
                return Math.max(...elementList.map(ele => {
                    // 注意，这里不能直接读取ele.style.left，这样只能读到终点位置的偏移量，而我们需要的是当前元素的实际位置，需要通过getComputedStyle来获取
                    const styles = getComputedStyle(ele, null)
                    return parseFloat(styles.left)
                }))
            }
        }
    }
</script>

<style scoped>
    .scroll-container {
        width: 100%;height: calc(100% - 50px);display: flex;
        flex-direction: row;position: relative;overflow: hidden;
    }

    .scroll-item {
        display: flex;flex-shrink: 0;width: 200px;height: 100%;
        position: absolute;transition-property: left;
        transition-timing-function: linear;
    }

    .btn {
        margin-top: 20px;height: 30px;line-height: 30px;
    }
</style>